export var DATE_FORMATS = [{
  label: 'widget_customization_date_formats.original',
  value: 'original'
}, {
  label: 'widget_customization_date_formats.YYYY-MM-DD',
  value: 'YYYY-MM-DD'
}, {
  label: 'widget_customization_date_formats.DD-MM-YYYY',
  value: 'DD-MM-YYYY'
}, {
  label: 'widget_customization_date_formats.MM-DD-YYYY',
  value: 'MM-DD-YYYY'
}, {
  label: 'widget_customization_date_formats.hidden',
  value: 'hidden'
}];
export var TIME_FORMATS = [{
  label: 'widget_customization_time_formats.12-hour-clock',
  value: 'hh:mmA'
}, {
  label: 'widget_customization_time_formats.24-hour-clock',
  value: 'HH:mm'
}, {
  label: 'widget_customization_time_formats.hidden',
  value: 'hidden'
}];